export default __webpack_public_path__ + "static/media/logo.020a90b4.png";